/** Controlled jurisdiction registry for introduction boundary language. Keyed by geofips. */

export interface UnresolvedBoundaryCopy {
  id: string;
  scopeBoxLine: string;
  block3Paragraphs: string[];
}

export interface JurisdictionIntroRegistryEntry {
  geofips: number;
  unresolvedBoundaries: UnresolvedBoundaryCopy[];
  suppressElectricityProviderName: boolean;
}

export const DAVIS_GEOFIPS = 618100;
export const FRESNO_GEOFIPS = 627000;

const UC_DAVIS_BOUNDARY: UnresolvedBoundaryCopy = {
  id: 'uc_davis_campus',
  scopeBoxLine: 'Treatment of the UC Davis campus remains unresolved.',
  block3Paragraphs: [
    'Treatment of the UC Davis campus remains unresolved. ClimatePlans does not currently document whether campus energy, university housing, campus-generated travel, waste, or cross-boundary trips are included, excluded, or divided between jurisdictions. This report does not infer that treatment from geographic knowledge. Until the boundary is documented, the inventory-year total should be read as ClimatePlans estimates for included sources, not as a complete picture of the Davis–UC Davis system.',
  ],
};

const REGISTRY: Record<number, JurisdictionIntroRegistryEntry> = {
  [DAVIS_GEOFIPS]: {
    geofips: DAVIS_GEOFIPS,
    unresolvedBoundaries: [UC_DAVIS_BOUNDARY],
    suppressElectricityProviderName: true,
  },
};

export function jurisdictionIntroRegistry(geofips: number | null | undefined): JurisdictionIntroRegistryEntry | null {
  if (geofips == null) return null;
  return REGISTRY[geofips] ?? null;
}
